import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M5.466 4.728V12h1.317V9.337h1.341L9.553 12h1.47L9.449 9.12q.072-.028.139-.06a1.97 1.97 0 0 0 .87-.792q.299-.516.299-1.214 0-.696-.295-1.219a2 2 0 0 0-.863-.816q-.57-.292-1.407-.291zm2.524 1.1q.494 0 .806.146a.97.97 0 0 1 .466.419q.152.274.152.66 0 .389-.152.654a.96.96 0 0 1-.462.401q-.313.135-.803.135H6.783V5.828z" }, null, -1)
  ]))]))
}
export default { render: render }